/** @jsx jsx */
import { jsx } from '@emotion/core';

import {
  Grid, Typography, useMediaQuery,
  useTheme
} from '@material-ui/core';
import { RouteComponentProps } from '@reach/router';
import React, { Fragment } from 'react';
import { OneTimePayConfigData } from '../payment-form/oneTimePayment.types';
import { useTranslation } from '../../hooks/useTranslation';
import useContentMgmt from '../../hooks/useContentMgmt';
import microcopyGroupIds from '../pge-plus-common/microcopyGroupIds';
import routes from '../../routes';
import PaymentInfoForm from '../payment-form/payment-info-form';
import usePaymentForm from '../../hooks/usePaymentForm';
import Backdrop from '../backdrop';
import useOneTimePayment from '../../hooks/invoice-payment-portal/useOneTimePayment';
import { InvoiceDetails } from '../../__generated__/pge-types';
import { formatDate } from '../../util/format';

type Props = RouteComponentProps & {
  paymentInfo: OneTimePayConfigData | null;
  onSubmit: (data: OneTimePayConfigData) => void;
  invoice: InvoiceDetails | null;
};

const PaymentInfo: React.FC<Props> = ({
  paymentInfo,
  onSubmit,
  invoice
}) => {
  const payBillProps = usePaymentForm();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const childProps = { isMobile, ...payBillProps };
   const { t } = useTranslation();
  const { content } = useContentMgmt(
    microcopyGroupIds.INVOICE_PAYMENT_FORM,
  );
  const paymentMethodCapLimit: number = 2;
  const { savedProfileList } = useOneTimePayment({
      skipAccountInfo: true,
  });
    
  const handleEligibleValue = (value: boolean) => {
    return false;
  };
 
  if (
    savedProfileList === undefined
  ) {
    return <Backdrop forceOpen />;
  }
  return (
    <Fragment>
      <Grid
        container
        justify={'center'}
        alignItems={'center'}
        direction="column"
      >
       <Grid item xs={12}>
        <Typography variant="h1">{content.get('INVOICE_PAYMENT_INFO_TITLE')}</Typography>
        </Grid>
        <Grid
          item
          css={{
            width: '100%',
            '& #navigation-panel': { display: 'center' },
          }}
        >
          <PaymentInfoForm
            path={routes.INVOICE_PAYMENT_PORTAL_INVOICE_PAYMENT_INFO}
            {...childProps}
            disableSplitPay={true}
            savedProfileList={savedProfileList}
            onSubmit={onSubmit}
            handleEligible={handleEligibleValue}
            oneTimePayConfigData={paymentInfo}
            paymentMethodCapLimit={paymentMethodCapLimit}
            defaultAmount={invoice?.amountDue || 0}
            maximumAmount={invoice?.amountDue || 0}
            paymentInfo={{
              amountDue: invoice?.amountDue || 0,
              dueDate: formatDate(new Date(invoice?.dueDate),'MM/dd/yyyy'),
            }}
            disableAmountField={true}
            disableDateField={true}
            nextButtonText={content.get('REUSABLE_BUTTON_NEXT')}
            disableNextButton={false}
            backButtonText={content.get('REUSABLE_BUTTON_BACK')}
            backButtonRoute={routes.INVOICE_PAYMENT_PORTAL_INVOICE_LIST}
            enableDonation={false}
            invoicePayment={true}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default PaymentInfo;
